import React from 'react';
import { Switch, Redirect } from 'react-router-dom';
import { useStyletron } from 'baseui';
import _map from 'lodash/map';
import _values from 'lodash/values';
import _isNil from 'lodash/isNil';
import _isEmpty from 'lodash/isEmpty';
import queryString from 'query-string';
import { AppBarLayout, Breadcrumbs, Loader } from 'commons-ui';

import { USER_PROFILE_RESOURCES, PAGE_NAMES } from 'constant';
import AuthorizedRouteV2 from 'commons-ui/src/permission/AuthorizedRoute';
import { ACL_CRM_RESOURCES } from '../constants';

import UserProfileHome from './UserProfileHome';
import { URL, COMPONENT } from './helper';
import SelectUser from './selectUser';
import useUserProfile, { FETCH_USER_STATUS } from './useUserProfile';

const UserProfile: React.FC<{}> = () => {
	const [css] = useStyletron();
	const { userSearchDetails, fetchUserStatus, queryParams } = useUserProfile();

	const redirectUrl = () => {
		if (_isNil(queryParams) || _isEmpty(queryParams)) {
			if (!_isNil(userSearchDetails) && !_isEmpty(userSearchDetails)) {
				const { selectionType, selectedValue } = userSearchDetails;
				const searchString = `?${queryString.stringify({ [selectionType || '']: selectedValue })}`;
				return <Redirect to={`/${PAGE_NAMES.userProfile}/home${searchString}`} />;
			}
			return <Redirect to={`/${PAGE_NAMES.userProfile}/selectUser`} />;
		}
		return <Redirect to={`/${PAGE_NAMES.userProfile}/home${queryParams}`} />;
	};

	return (
		<>
			<AppBarLayout />
			<Breadcrumbs />
			<div className={css({ height: 'calc(100% - 110px)', overflow: 'auto' })}>
				{fetchUserStatus === FETCH_USER_STATUS.PENDING || fetchUserStatus === FETCH_USER_STATUS.NOT_STARTED ? (
					<Loader />
				) : (
					<Switch>
						<AuthorizedRouteV2
							exact
							configPageName={PAGE_NAMES.userProfile}
							path={`/${PAGE_NAMES.userProfile}/selectUser`}
							component={SelectUser}
						/>
						<AuthorizedRouteV2
							exact
							configPageName={PAGE_NAMES.userProfile}
							path={`/${PAGE_NAMES.userProfile}/home`}
							component={UserProfileHome}
						/>
						{_map(_values(USER_PROFILE_RESOURCES), (resourceName: string) => {
							if (ACL_CRM_RESOURCES.includes(resourceName)) {
								return (
									<AuthorizedRouteV2
										configPageName={PAGE_NAMES.userProfile}
										configResourceName={resourceName}
										path={URL[resourceName]}
										component={COMPONENT[resourceName]}
									/>
								);
							}
							return (
								<AuthorizedRouteV2
									// key={resourceName}
									configPageName={PAGE_NAMES.userProfile}
									configResourceName={resourceName}
									path={URL[resourceName]}
									component={COMPONENT[resourceName]}
								/>
							);
						})}
						{redirectUrl()}
					</Switch>
				)}
			</div>
		</>
	);
};

export default UserProfile;
